import React from 'react';
import ReactDOM from 'react-dom';

import Root from './containers/Root';
import './i18n';

ReactDOM.render(<Root />, document.getElementById('app'));
